import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';
import { TansactionService } from 'src/app/shared/services/node-api/tansaction.service';

@Component({
  selector: 'app-transaction-fail-component',
  templateUrl: './transaction-fail-component.component.html',
  styleUrls: ['./transaction-fail-component.component.scss'],
})
export class TransactionFailComponentComponent implements OnInit {
  cart: any;
  constructor(private transactionService: TansactionService) {}

  ngOnInit(): void {
    this.transactionService
      .getCartDetails()
      .then((data) => {
        this.cart = data;
      })
      .catch((err) => {
        console.log(err);
      });
  }
}
